import React from 'react';
import { FieldLabelProps } from '@common/types/hilbi-form';
import { FieldLabelSC } from './field-label.styled';

const FieldLabel: React.FC<FieldLabelProps> = ({ label }) => {
  return <FieldLabelSC className={'field-label'}>{label}</FieldLabelSC>;
};

export default FieldLabel;
